import React from "react"
import { Container } from "reactstrap"
import Tabs from "./Tabs"

import "./style.css"

const AdminHeader = () => {
  return (
    <Container className="text-center main-dashboard">
      <h2>HDForm Administration</h2>
    </Container>
  )
}

const Dashboard = () => {
  return (
    <Container>
      <AdminHeader />
      <Tabs />
    </Container>
  )
}

export default Dashboard
